export enum DashboardViewEnum {
  work = 'work',
  analyze = 'analyze',
}
